// Module
var code = "<div class=\"mx-custom-content-widget\" mx-service-context=\"vm.dataModel\" mx-service-context-info=\"vm.serviceContextInfo\" ng-if=\"vm.dataModel\">\r\n\r\n\t<mx-content-widget-view ng-if=\"vm.widgetId\" data-view=\"vm.view\" data-parameters=\"vm.dataModel\">\r\n\t</mx-content-widget-view>\r\n\r\n</div>\r\n\r\n";
// Exports
export default code;